<template>
  <div class="funfacts-area pt-100 pb-75 bg-fff4f8">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-3 col-sm-3 col-6" data-aos="fade-up" data-aos-duration="1200">
          <div class="single-funfacts-box">
            <div class="icon">
              <i class="flaticon-employee"></i>
            </div>
            <h3>25</h3>
            <p>PROJETOS ENTREGUES</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3 col-6" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
          <div class="single-funfacts-box">
            <div class="icon">
              <i class="flaticon-projects"></i>
            </div>
            <h3>18</h3>
            <p>CLIENTES ATIVOS</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3 col-6" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
          <div class="single-funfacts-box">
            <div class="icon">
              <i class="flaticon-rating"></i>
            </div>
            <h3>15</h3>
            <p>ANOS DE EXPERIÊNCIA</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-3 col-6" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="300">
          <div class="single-funfacts-box">
            <div class="icon">
              <i class="flaticon-expert"></i>
            </div>
            <h3>100%</h3>
            <p>SATISFAÇÃO CLIENTES</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Funfacts'
}
</script>